import React, { useState } from 'react';
import Card from '@components-clean/core/card';
import CoreSplitter from '@components-clean/core/core-splitter';
import { InfoField } from '@components-clean/core/info-field';
import { OpraReportTemplate } from '@interfaces/report-templates.interface';
import { GeneratedReportsGrid } from '@pages-clean/shared/generated-reports/generated-reports-grid';
import { ReportTemplateGrid } from '@pages-clean/shared/report-template-grid/report-template-grid';
import { IUser } from '@contexts/user-context';
import { useTranslation } from '@hooks/index';
import { SplitterOrientation } from '@utils/constants';

type Props = {
    studyId: string;
    module: number;
    user: IUser;
};

// TODO: UAM
// TODO: Child Grid Empty State when no parent selected
// TODO: Splitter pane sizes and min sizes

const ManageReports = ({ studyId, module, user }: Props) => {
    const [currentTemplate, setCurrentTemplate] = useState<OpraReportTemplate>();
    const { t } = useTranslation();

    return (
        <CoreSplitter
            className="!k-h-full"
            data-testid="manage-reports-splitter"
            orientation={SplitterOrientation.vertical}
        >
            <ReportTemplateGrid
                module={module}
                studyId={studyId}
                orgKey={user.organisationKey}
                onTemplateSelected={(template) => setCurrentTemplate(template)}
            />
            {currentTemplate ? (
                <GeneratedReportsGrid
                    user={user}
                    orgKey={user.organisationKey}
                    module={module}
                    studyId={studyId}
                    currentTemplate={currentTemplate}
                />
            ) : (
                <Card
                    data-testid="data-view-details-pane"
                    title={<span>{t('cm:generatedReports')}</span>}
                    className="k-h-full"
                >
                    <InfoField message={t('reports:noTemplateSelected')} type="Info" layout="center" />
                </Card>
            )}
        </CoreSplitter>
    );
};
export default ManageReports;
